<template>
    <div v-if="count" ref="container" :style="{minHeight: '100px'}">
      <div><small>{{count}}-Day Traffic</small></div>
      <Sparkline v-if="sorted.length && width && status != 'completed'" :data="values" :options="options" v-b-tooltip.hover.right  v-model="tooltip" :title="title" :width="width" :height="30" />
      <div class="text-small">
        {{'click'|pluralize(total)}}, 
        <span v-if="potential > 0" class="potential"><span class="⨦">⨦</span>{{potential|toMonthly|formatNumber}} potential</span>
      </div>
      <div v-if="delta_month !== null" class="text-muted text-small">
        {{delta_month|formatNumber(true)}}% month-over-month
      </div>
      <div v-if="improved_at !== null" class="text-muted text-small">
        <b-badge v-if="site_clicks_delta !== null" :variant="site_clicks_delta < 0 ? 'danger' : 'success'">{{(site_clicks_delta * 100)|formatNumber(true)}}%</b-badge>
        <b-icon-clock v-else v-b-tooltip="`Traffic data has not been collected yet`" />
        vs site average since {{improved_at|formatDate}}
      </div>
    </div>
</template>
<script>
import {isEmpty, sum, first, last, get, orderBy} from 'lodash'
import Sparkline from '@/components/Sparkline'
import PAGE_TRAFFIC_QUERY from '@/graphql/PageTrafficQuery.gql'
import PAGE_TRAFFIC_TOTAL_QUERY from '@/graphql/PageTrafficTotalQuery.gql'
const SEARCHCONSOLE_DAYS = 28

export default {
  name: 'PageTraffic',
  components: { Sparkline },
  props: ['page_id', 'status', 'potential', 'site_clicks_delta', 'delta_month',  'this_month', 'last_month', 'improved_at'],
  
  data: function() {
    return {
      page_traffic: [],
      tooltip: {},
    }
  },

  apollo: {
    page_traffic: {
      query: PAGE_TRAFFIC_QUERY,
      variables() {
        return {
          page_id: this.page_id,
          limit: SEARCHCONSOLE_DAYS,
        }
      },
    },
  },
  computed: {
    width() {
      const maxWidth = 220
      const pixelsPerDay = maxWidth / SEARCHCONSOLE_DAYS
      return this.count * pixelsPerDay
    },
    sorted() {
      return orderBy(this.page_traffic, 'date')
    },
    isLoading() {
      return this.$apollo.queries.page_traffic.loading
    },
    values() {
      return this.sorted.map(e => e.clicks)
    },
    options() {
      if(!this.sorted.length) {
        return {}
      }
      const diff = last(this.sorted).clicks - first(this.sorted).clicks
      return {endColor: diff > 0 ? 'green' : diff < 0 ? 'red' : 'black'}
    },
    count() {
      return this.page_traffic.length
    },
    total() {
      return sum(this.values)
    },
    title() {
      if(this.tooltip.index !== undefined && this.sorted[this.tooltip.index]) {
        const date = new Date(this.sorted[this.tooltip.index].date)
        const val = this.tooltip.value || 0
        const dateStr = date.toLocaleDateString()
        return `${dateStr}: ${val} click${val === 1 ? '' : 's'}`
      }
      return null
    },
  },
}
</script>
